// @flow
import * as React from "react";

import Link from "./Link";

function Advertisers() {
  return (
    <li className="nav-item">
      <Link to="/advertisers" className="nav-link">
        Advertisers
      </Link>
    </li>
  );
}

function Affiliates() {
  return (
    <li className="nav-item">
      <Link to="/affiliates" className="nav-link">
        Affiliates
      </Link>
    </li>
  );
}

const Billing = {
  Affiliate: function () {
    const handleClick = (event: SyntheticEvent<HTMLLinkElement>) => {
      event.preventDefault();
    };

    return (
      <li className="nav-item dropdown">
        <Link to="/billing" className="nav-link" onClick={handleClick}>
          Billing
        </Link>
        <div className="dropdown-content">
          <Link to="/billing/invoices">Invoices</Link>
          <Link to="/billing/payment-methods">Payment methods</Link>
        </div>
      </li>
    );
  },
  Manager: function () {
    return (
      <li className="nav-item">
        <Link to="/billing" className="nav-link">
          Billing
        </Link>
      </li>
    );
  },
};

function ControlPanel() {
  const handleClick = (event: SyntheticEvent<HTMLLinkElement>) => {
    event.preventDefault();
  };

  return (
    <li className="nav-item dropdown">
      <Link to="/control-panel" className="nav-link" onClick={handleClick}>
        Control panel
      </Link>
      <div className="dropdown-content">
        <Link to="/control-panel/users">Users</Link>
        <Link to="/control-panel/configuration">Configuration</Link>
        <Link to="/control-panel/schedulers">Schedulers</Link>
      </div>
    </li>
  );
}

function Dashboard() {
  return (
    <li className="nav-item">
      <Link to="/dashboard" className="nav-link">
        Dashboard
      </Link>
    </li>
  );
}

function Offers() {
  return (
    <li className="nav-item">
      <Link to="/offers" className="nav-link">
        Offers
      </Link>
    </li>
  );
}

function Postbacks() {
  return (
    <li className="nav-item">
      <Link to="/postbacks" className="nav-link">
        Postbacks
      </Link>
    </li>
  );
}

const Statistics = {
  Affiliate: function () {
    const handleClick = (event: SyntheticEvent<HTMLLinkElement>) => {
      event.preventDefault();
    };

    return (
      <li className="nav-item dropdown">
        <Link to="/statistics" className="nav-link" onClick={handleClick}>
          Statistics
        </Link>
        <div className="dropdown-content">
          <Link to="/statistics/reports">Reports</Link>
          <Link to="/statistics/clicks">Clicks</Link>
        </div>
      </li>
    );
  },
  Manager: function () {
    const handleClick = (event: SyntheticEvent<HTMLLinkElement>) => {
      event.preventDefault();
    };

    return (
      <li className="nav-item dropdown">
        <Link to="/statistics" className="nav-link" onClick={handleClick}>
          Statistics
        </Link>
        <div className="dropdown-content">
          <Link to="/statistics/reports">Reports</Link>
          <Link to="/statistics/clicks">Clicks</Link>
          <Link to="/statistics/conversions">Conversions</Link>
        </div>
      </li>
    );
  },
};

function SmartLink() {
  const link = "https://smartlink.vortexads.io";

  return (
    <li className="nav-item">
      <a href={link} className="nav-link" target="_blank" rel="noopener noreferrer">
        SmartLink
      </a>
    </li>
  );
}

export default {
  Affiliate() {
    return (
      <>
        <Dashboard />
        <Offers />
        <Statistics.Affiliate />
        <Postbacks />
        <Billing.Affiliate />
        <SmartLink />
      </>
    );
  },
  Manager() {
    return (
      <>
        <Dashboard />
        <Offers />
        <Affiliates />
        <Advertisers />
        <Statistics.Manager />
        <ControlPanel />
        <Billing.Manager />
        <SmartLink />
      </>
    );
  },
  AdvertiserManager() {
    return (
      <>
        <Dashboard />
        <Offers />
        <Affiliates />
        <Advertisers />
        <Statistics.Manager />
        <ControlPanel />
        <SmartLink />
      </>
    );
  },
};
